import React from 'react';
import { Box, Icon, Spacing, Text } from '@reservamos/elements';
import { useTranslation } from 'react-i18next';
import useWhitelabelTheme from 'hooks/whitelabel/useWhitelabelTheme';

/**
 * MobileSearchTrigger component.
 * Render a button to change the search route.
 *
 * @returns {JSX.Element} - React component
 */
const MobileSearchTrigger = () => {
  const { t } = useTranslation('search');
  const { headerTextColor } = useWhitelabelTheme();

  return (
    <Box
      paddingVertical="XS"
      paddingHorizontal="XS"
      borderRadius="L"
      bgColor={headerTextColor}
      alphaBg={headerTextColor === 'primary' ? 'XS' : 'M'}
      hasHoverBg
      hasWidth
    >
      <div className="flex items-center justify-between w-52 gap-3 pl-2">
        <Text size="S" color={headerTextColor} weight="semibold">
          {t('label.change_search')}
        </Text>

        <Box bgColor="white" borderRadius="L" paddingHorizontal="S" paddingVertical="S">
          <Spacing alignItems="center" justifyContent="center">
            <Icon type="Search" size="S" color="primary" />
          </Spacing>
        </Box>
      </div>
    </Box>
  );
};

export default MobileSearchTrigger;
